import { useNavigate } from "react-router-dom";
import { useAuth } from "@hoteltradergit/user-management/auth";
import eyeCrossIcon from "../../assets/img/eye-cross.svg";
import "./unauthorized.scss";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { claims, logOut } = useAuth();
  const email = claims?.email || "";

  return (
    <div className="unauthorised-page">
      <div className="unauthorised-page__card">
        <div className="unauthorised-page__icon-wrapper">
          <img src={eyeCrossIcon} alt="" className="unauthorised-page__icon" />
        </div>
        <div className="unauthorised-page__content">
          <div className="unauthorised-page__text-group">
            <h1 className="unauthorised-page__title">
              You don&apos;t have access to this page
            </h1>
            <p className="unauthorised-page__description">
              Your access is restricted - you only have permission to view
              certain pages and features. Contact your administrator to learn
              more or request additional access.
            </p>
          </div>
          <button
            className="unauthorised-page__btn"
            onClick={() => navigate("/")}
          >
            Go to Homepage
          </button>
          <div className="unauthorised-page__footer">
            <span>You are currently logged in as {email}. </span>
            <span>
              <button
                className="unauthorised-page__logout-link"
                onClick={logOut}
              >
                Log out
              </button>
              .
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
